import { render } from "./EditarCorretor.vue?vue&type=template&id=1dad70da"
import script from "./EditarCorretor.vue?vue&type=script&lang=js"
export * from "./EditarCorretor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__